import { IFinderQueryType } from '@patsnap/synapse_common_business/dist/query-transform/type'
import { useAuthStore, useLocale } from '@pharmsnap/shared/src/composition'
import { computed } from '@vue/composition-api'
import { E_UPGRADE_TYPE } from '../types/enum'

export function useFinderLimit() {
  const {
    actions: { checkPatentSearchLimit, checkClinicalResultSearchLimit, checkDrugDealSearchLimit, checkTransMedicineSearchLimit },
  } = useAuthStore()
  const { isCN } = useLocale()
  const {
    actions: { changeUpgrade },
  } = useAuthStore()

  const finderOverLimitMap = computed<Partial<Record<IFinderQueryType, { title?: string; checkFunc: () => Promise<boolean> }>>>(() => ({
    patent: {
      title: isCN.value
        ? '您只可以在专利板块搜索20次，请升级您的订阅计划'
        : 'You can only search 20 times in the Patent. Please upgrade your personal plan',
      checkFunc: checkPatentSearchLimit,
    },
    clinical_trial_result: {
      title: isCN.value
        ? '您只可以在临床结果板块搜索20次，请升级您的订阅计划'
        : 'You can only search 20 times in the Clinical Result. Please upgrade your personal plan',
      checkFunc: checkClinicalResultSearchLimit,
    },
    drug_deal: {
      title: isCN.value
        ? '您只可以在药物交易板块搜索10次，请升级您的订阅计划'
        : 'You can only search 10 times in the Deal. Please upgrade your personal plan',
      checkFunc: checkDrugDealSearchLimit,
    },
    translational_medicine: {
      title: isCN.value
        ? '您只可以在转化医学板块搜索10次，请升级您的订阅计划'
        : 'You can only search 10 times in the Translational Medicine. Please upgrade your personal plan',
      checkFunc: checkTransMedicineSearchLimit,
    },
  }))

  const checkFinderSearchIsOverLimit = async (dataType: IFinderQueryType) => {
    const overLimitConfig = finderOverLimitMap.value[dataType]

    if (overLimitConfig) {
      const isOverLimit = await overLimitConfig.checkFunc()
      if (isOverLimit) {
        changeUpgrade({ show: true, type: E_UPGRADE_TYPE.EXCEEDS_SEARCH_MAX_LIMIT, trigger_point: `${dataType.toLocaleUpperCase()}_FINDER` })
        return true
      }
    }
    return false
  }

  return {
    finderOverLimitMap,
    checkFinderSearchIsOverLimit,
  }
}
